import type { Options } from 'ky';
import ky from 'ky';

export const XCsrfHeaderName = 'X-CSRF-TOKEN';

export default function fetcher<T>(url: string, options?: Options): Promise<T> {
  return ky.get(url, options).json<T>();
}
